const homeHeroImages = [
  "https://ir.ebaystatic.com/cr/v/c01/ebay-design/home-card-1.png",
  "https://ir.ebaystatic.com/cr/v/c01/ebay-design/home-card-2.jpg",
  "https://ir.ebaystatic.com/cr/v/c01/ebay-design/home-card-3.jpg",
  "https://ir.ebaystatic.com/cr/v/c01/ebay-design/home-card-4.jpg",
  "https://ir.ebaystatic.com/cr/v/c01/ebay-design/home-card-5.png",
];

export { homeHeroImages };
